import { View } from 'react-native';

export const EcoSeparator = (): JSX.Element => {
  return <View className="bg-gray-50 w-full" style={{ height: 1 }} />;
};
